export const GET_CLIENT_SUMMARY_YJC = 'GET_CLIENT_SUMMARY_YJC';
export const GET_CLIENT_SUMMARY_YJC_SUCCESS = 'GET_CLIENT_SUMMARY_SUCCESS';
export const SAVE_CLIENT_SUMMARY_YJC = 'SAVE_CLIENT_SUMMARY_YJC';
export const CLIENT_SUMMARY_YJC_ERROR = 'CLIENT_SUMMARY_YJC_ERROR';
